class HttpClient {
    static httpClientStore = {};

    constructor(hostname, options = {}) {
        this.hostname = hostname || $("meta[name=data-api-origin]").attr("content");
        this.defaultOptions = {
            // timeout: 30 * 1000,
            contentType: "application/json",
            crossOrigin: true,
            ...options,
        };
    }

    // Format URL consistently in one place
    _formatUrl(url) {
        if (!url.toLowerCase().startsWith("http")) {
            url = this.hostname + url;
        }
        return url.replace(/\/+$/, "").replace(/\/\?+/, "?");
    }

    // Clean up completed requests
    _cleanupRequest(apiUrl, promise) {
        // Use .always() for jQuery promises or .finally() for native Promises
        if (typeof promise.always === "function") {
            promise.always(() => {
                delete HttpClient.httpClientStore[apiUrl];
            });
        } else if (typeof promise.finally === "function") {
            promise.finally(() => {
                delete HttpClient.httpClientStore[apiUrl];
            });
        } else {
            // Fallback for older environments
            promise.then(
                () => {
                    delete HttpClient.httpClientStore[apiUrl];
                },
                () => {
                    delete HttpClient.httpClientStore[apiUrl];
                },
            );
        }
        return promise;
    }

    // Generic request method to reduce duplication
    _fetch(url, method, data, options = {}) {
        const apiUrl = this._formatUrl(url);

        // For GET requests, reuse in-progress requests
        if (method === "GET" && HttpClient.httpClientStore[apiUrl]) {
            // console.log(`Request to ${apiUrl} is already in progress.`);
            return HttpClient.httpClientStore[apiUrl];
        }

        const requestOptions = {
            ...this.defaultOptions,
            url: apiUrl,
            type: method,
            data: data,
            ...options,
        };

        const promise = $.ajax(requestOptions);

        // Store only GET requests to avoid duplicates
        if (method === "GET") {
            HttpClient.httpClientStore[apiUrl] = promise;
        }

        return promise;
    }

    async _request(url, { method = "GET", data = {}, errorHandler = () => {}, options = {} }) {
        try {
            const response = await this._fetch(url, method, data, options);
            return response;
        } catch (err) {
            // Log the raw error first
            // console.error(`${method} request to ${url} failed:`, err);

            // Call the provided error handler
            errorHandler(err);

            // Create a more informative error message
            let errorMsg = `Request to ${url} failed`;

            // Check if it's a network error
            if (err.status) {
                errorMsg += ` (Status: ${err.status})`;
            }

            // Check for timeout
            // if (err.statusText === "timeout") {
            //     errorMsg += ` - Request timed out`;
            // }

            // Add a timestamp for debugging
            errorMsg += ` at ${new Date().toISOString()}`;

            throw new Error(errorMsg);
        }
    }

    // Simplified API methods using the generic request method
    async get(url, options = {}) {
        return this._request(url, { method: "GET", ...options });
    }

    async post(url, options = {}) {
        return this._request(url, { method: "POST", ...options });
    }
}

export default HttpClient;
